export const QuickBetsIcon = () => {
  return (
    <svg fill="none" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg">
      <circle cx="6" cy="6" fill="#FB0" r="6" />
      <g clipPath="url(#clip0)">
        <path d="M8.515 5.195H6.23l1.214-2.528H4.698l-1.213 4.16h1.95l-.864 3.84 3.944-5.472z" fill="#20242E" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path d="M0 0H6.667V8H0z" fill="#fff" transform="translate(2.667 2.667)" />
        </clipPath>
      </defs>
    </svg>
  );
};
